//配件余额
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="帐务流水" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :_createTime.sync="createTime"
          :parent-target="_self" @reload="$reloadHandle" :type="editViewType"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="active1" style="padding-bottom: 35px">
          <vxe-grid show-overflow height="auto" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle" :checkbox-config="{
              labelField: '',
              highlight: true,
              reserve: true,
              range: true,
            }">
            <template #form>
              <div class="clearfix screen-btns" style="padding-bottom: 6px">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top" @click="doExcel">导出
                  </vxe-button>
                  <vxe-button v-if="permissions.sanBaoBalanceImport" status="primary" class="button-sty"
                    icon="el-icon-bottom" @click="$refs.excelUpload.show()">调账
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 0 0 10px" class="button-sty"
                    @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">
                <vxe-form ref="form" class="screen-box" title-width="7vw" title-align="right" :data="formData"
                  @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="服务中心:" field="name" v-if="!currentIsSite">
                    <template v-slot>
                      <org-search :org-name.sync="formData.orgName" :org-id-path.sync="formData.orgIdPath"
                        :org-id.sync="formData.orgId" />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务商:" field="name" v-if="!currentIsSite">
                    <template v-slot>
                      <el-input v-model="siteCode" clearable></el-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="冲账时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="createTime" type="daterange" align="right"
                        unlink-panels range-separator="-" :picker-options="pickerOptions" value-format='yyyy-MM-dd HH:mm:ss' :default-time="['00:00:00', '23:59:59']">
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>
            </template>

            <template #option="{ row }">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.siteCode)">
                  <el-tooltip enterable={false} effect="dark" content="帐务流水" placement="top"
                    popper-class="tooltip-skin">
                    <i class="el-icon-document" />
                  </el-tooltip>
                </a>
              </div>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect" :visiable.sync="showOrgDialog" multi="true" />
    <excel-upload 
      ref="excelUpload" 
      title="数据导入" 
      temp-url="/admin/sys-file/local/file/sanBaoPartsBalance.xlsx"
      url="/basic/sanBaoPartsBalance/importByExcel"
      @refreshDataList="getTableData">
    </excel-upload>
  </div>
</template>

<script>
import editView from "./edit.vue";
import { initVxeTable } from "@/const/crud/admin/table";
import pager from "@/components/pager/index.vue";
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import { siteMixins } from "@/mixins/tabChang";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import { doCheckExcle, doDownLoadExcle } from "@/api/intfDownloadRecord/downloadRecord";
import ExcelUpload from "@/components/upload/excel.vue";
import { getTableData } from "@/api/gen/dynamic";
export default {
  name: "balance",

  mixins: [siteMixins],
  components: {
    ExcelUpload,
    OrgSearch,
    editView,
    pager,
  },
  data() {
    return {
      editViewType: null,

      showOrgDialog: false,

      total: 0,
      siteCode: "",
      createTime: null,
      requestParam: {
        searchCount: false, // 是否分页
        current: 1, // 当前页面
        size: 0, // 页面数据量
      },

      formData: {
        siteCode: [],
        orgId: null,
        orgName: null,
        orgIdPath: null,
        createTime: null
      },

      activeName: "second",
      dataId: 0,

      vxeOption: {},
      // 查询参数
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        { title: "服务中心", field: "orgName", width: 100 },
        { title: "服务商账号", field: "siteCode", width: 100 },
        { title: "服务商名称", field: "siteName", width: 160 },
        { title: "期初余额", field: "openingBalance", width: 90 },
        { title: "旧件核销上账金额", field: "scrappedPartWriteOffAmount", width: 100 },
        { title: "产品退货上账金额", field: "productReturnWriteOffAmount", width: 100 },
        { title: "特殊费用申请上账金额", field: "specialFeeWriteOffAmount", width: 100 },
        { title: "记账订单金额", field: "accountedOrderAmount", width: 90 },
        { title: "扣款金额", field: "deductionAmount", width: 90 },
        { title: "期末余额", field: "closingBalance", width: 90 },
        { title: "实际余额", field: "balance", width: 90 },
        { title: "可用余额", field: "availableBalance", width: 90 },
        { title: "占用金额", field: "occupiedAmount", width: 90 }
      ],
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal;
    },
  },
  created() {
    // 设置日期范围为当前月份的开始和结束日期
    const start = new Date();
    start.setDate(1); // 设置为本月第一天
    start.setHours(0, 0, 0, 0); // 设置时间为当天开始

    const end = new Date();
    end.setHours(23, 59, 59, 999); // 设置时间为当天开始
    
    // 由于日期选择器配置了 value-format='yyyy-MM-dd'，需要将Date对象转换为字符串格式
    // 以保持一致性，避免时区问题
    this.createTime = [
      this.formatDateToYYYYMMDD(start),
      this.formatDateToYYYYMMDD(end)
    ];
  },

  mounted() { },

  methods: {
    
    toFilterData() {
      // console.log(55,"触发了搜索");
      // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
      if (this.formData === "") {
        return;
      } else {
        // 请求查询接口，将列表展现出来
        this.searchEvent();
      }
    },


    //确定选择机构
    commitOrgSelect(data) {
      console.log("机构数据", data);
      this.formData.orgId = data.id;
      this.formData.orgIdPath = data.orgIdPath;
      this.formData.orgName = data.name;
    },

    flushed() {
      this.$refs["table-m1"].commitProxy("reload");
    },


    // 加载table数据
    getTableData() {
      this.handleFormData()
      Object.assign(this.requestParam, this.formData)
      let tableOption = {
        vue: this,
        tableRef: "table-m1",
        path: api.sanBaoPartsBalance.getSanBaoPartsBalanceUrl,
        param: this.requestParam,
        method: "post",
        columns: this.columns,
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed();
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize;
      this.requestParam.current = page.currentPage;
      this.requestParam.searchCount = flag;
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal();
      this.requestParam.current = 1;
      this.requestParam.searchCount = false;
      this.$refs.pager.reset(); // 重置分页器
      this.getTableData();
    },
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      // 确保在打开编辑页面之前，将当前的createTime值同步到编辑组件
      this.$nextTick(() => {
        this.$openEditView('showEdit');
      });
      console.log('触发了跳转');
    },


    doExcel() {
      this.$mask.open()
      this.handleFormData()
      Object.assign(this.requestParam, this.formData)
      doCheckExcle(fileNames.sanBaoBalance).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.sanBaoPartsBalance.getSanBaoPartsBalanceExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    handleFormData() {
      // 如果当前值是字符串，则按常用分隔符分割
      if (typeof this.siteCode === 'string') {
        // 常用分隔符包括：逗号、分号、空格、换行符、制表符等
        const separators = /[,\s;，；\n\t\r]+/;
        let splitValues = this.siteCode.split(separators);

        // 过滤掉空字符串
        splitValues = splitValues.filter(item => item.trim() !== '');

        // 限制列表最大为200
        if (splitValues.length > 200) {
          splitValues = splitValues.slice(0, 200);
          this.$message.warning(`最多只能输入200个服务商账号，已截取前200个`);
        }

        this.formData.siteCode = splitValues;
      }
      if (this.createTime) {
        // 处理开始时间：确保转换为'yyyy-MM-dd'格式的字符串
        let beginTime = this.createTime[0];
        let endTime = this.createTime[1];

        // 如果是Date对象，转换为'yyyy-MM-dd'格式
        if (beginTime instanceof Date) {
          beginTime = this.formatDateToYYYYMMDD(beginTime);
        }
        if (endTime instanceof Date) {
          endTime = this.formatDateToYYYYMMDD(endTime);
        }

        this.formData.beginTime = beginTime;
        this.formData.endTime = endTime;
      } else {
        this.formData.beginTime = null;
        this.formData.endTime = null;
      }
    },

    /**
     * 将Date对象格式化为'yyyy-MM-dd HH:mm:ss'字符串
     * @param {Date} date - 日期对象
     * @returns {string} 格式化后的日期时间字符串
     */
    formatDateToYYYYMMDD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }


  },
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}

// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}

.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;
}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #ebeef5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;
}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
  display: inline-block;
  // width: 20%;
}
</style>
